import { calcularDiferenciaDeTiempo, calcularSegundosHoraSeleccionada, calcularTiempoMaxLimite, convertirHoraIntervalo30Minutos, formatDate, horaActualSistema, obtenerSegundosEntreFechas, texto, verificarHoras } from '@/shared';
import { getCache, postCache, postHorasDisponiblesFlota, putPlanificationBlock, unblockManyHours } from '@/shared/actions/erp';
import { AlertSeverityEnum, CacheKeyCalendarioENUM, ICalendarioProps, TiempoBloqueoENUM, } from '@/shared/interfaces';
import { IFechasDisponible, IHorasDisponibles } from '@/shared/interfaces/erp/system-settings/horas-libres-flota.interface';
import { useAuthStore } from '@/store/auth';
import { useUiStore } from '@/store/ui';
import { NavigateFunction } from 'react-router-dom';
import { create } from 'zustand';

interface IFlotaInstalacionStoreNew {

  horasSelect: number[];
  setHoraSelect: (horasSelect: number[]) => void;

  currentIndex: number;
  setCurrentIndex: (currentIndex: number) => void;

  isLoadingPlanificacion: boolean;
  setIsLoadingPlanificacion: (isLoadingPlanificacion: boolean) => void;

  minDate: string | null;
  setMinDate: (minDate: string) => void;

  maxDate: string | null;
  setMaxDate: (maxDate: string) => void;

  modal: boolean;
  setModal: (modal: boolean) => void;

  idPreventa: string | null;
  setIdPreventa: (idPreventa: string | null) => void;

  bloquear: boolean;
  setBloquear: (bloquear: boolean) => void;

  countdown: number;
  setCountdown: (segundos: number) => void;

  clickedIdHora: string | null;
  setClickedIdHora: (clickedIdHora: string | null) => void;

  fechaHoraDisponible: IFechasDisponible[] | null;
  setFechaHoraDisponible: (fechaHoraDisponible: IFechasDisponible[] | null) => void;

  horasDisponibles: IHorasDisponibles[];
  setHorasDisponibles: (horasDisponibles: IHorasDisponibles[]) => void;

  codigoFlota: string | null;
  setCodigoFlota: (codigoFlota: string | null) => void;

  fechaSelecionada: string | null;
  setFechaSelecionada: (fechaSelecionada: string) => void;

  countdownInterval: NodeJS.Timeout | null;
  setCountdownInterval: () => void;

  countdownTimeOut: NodeJS.Timeout | null;
  setCountdownTimeOut: (milisegundos: number, desbloquear?: boolean, alerta?: boolean) => void;

  /* setAux: (aux: boolean) => void;
  aux: boolean; */

  handleVerificarCache: (key: string, codigoFlota: string, idPreventa: string, navigate?: NavigateFunction) => Promise<ICalendarioProps | null>;
  handleRecargarHoras: () => void;
  handleFechaCalendario: (fecha: string) => boolean;
  handleVerificarHoraSeleccionada: (hora: number) => void;
  handleObtenerPlanificacion: (codigoFlota: string) => void;

}


const useCalendarioInstalacion = create<IFlotaInstalacionStoreNew>((set, get) => ({

  horasSelect: [],
  setHoraSelect: (horasSelect) => {
    set({ horasSelect })
  },

  currentIndex: 0,
  setCurrentIndex(currentIndex) {
    set({ currentIndex })
  },

  isLoadingPlanificacion: false,
  setIsLoadingPlanificacion(isLoadingPlanificacion) {
    set({ isLoadingPlanificacion })
  },
  minDate: null,
  setMinDate(minDate) {
    set({ minDate })
  },

  maxDate: null,
  setMaxDate(maxDate) {
    set({ maxDate })
  },

  modal: false,
  setModal(modal) {
    set({ modal })
  },

  idPreventa: null,
  setIdPreventa(idPreventa) {
    set({ idPreventa })
  },

  bloquear: false,
  setBloquear(bloquearCalendario) {
    set({ bloquear: bloquearCalendario });
  },

  countdownTimeOut: null,
  async setCountdownTimeOut(milisegundos, desbloquear = false, alerta = false) {

    const setAlert = useUiStore.getState().setAlert;


    const { countdownTimeOut,
      countdownInterval,
      fechaSelecionada,
      codigoFlota,
      clickedIdHora,
      idPreventa,
      horasSelect,
      //aux,
    } = useCalendarioInstalacion.getState();

    const timeOut = setTimeout(async () => {

      if (desbloquear && clickedIdHora) {
        //let hora = +clickedIdHora.replace('id-', '');

        await unblockManyHours({
          fecha: fechaSelecionada!,
          flota: codigoFlota!,
          horas: horasSelect,
        })

        await postCache({
          key: `${CacheKeyCalendarioENUM.KEY_CACHE_PREAGENDAMIENTO}${idPreventa}`,
          value: null,
        });
        //set({ fechaHoraDisponible: null })
      }

      if (alerta) setAlert(true, 'Tiempo terminado.', AlertSeverityEnum.info)

      //set({ codigoFlota: '' });
      set({ bloquear: false })
      //set({ fechaSelecionada: null })
      //set({ fechaHoraDisponible: null })
      set({ horasSelect: [] })
      set({ horasDisponibles: [] })
      set({ countdown: TiempoBloqueoENUM.COUNTDOWNINTERVAL })
      set({ clickedIdHora: null })
      set({ countdownTimeOut: null });

      if (countdownTimeOut) {
        clearTimeout(countdownTimeOut)
      }

      if (countdownInterval) {
        clearTimeout(countdownInterval)
      }

    }, milisegundos);


    set({ countdownTimeOut: timeOut })

  },
  countdownInterval: null,
  setCountdownInterval: () => {
    const countdownInterval = setInterval(() => {
      set((state) => ({
        countdown: state.countdown - 1
      }));
    }, 1000);

    set({ countdownInterval });
  },
  countdown: TiempoBloqueoENUM.COUNTDOWNINTERVAL,
  setCountdown(countdown) {
    set({ countdown })
  },

  clickedIdHora: null,
  async setClickedIdHora(value) {
    const { setCountdownInterval,
      setCountdownTimeOut,
      fechaSelecionada,
      codigoFlota,
      idPreventa,
      clickedIdHora,
      currentIndex,
      horasSelect,
    } = useCalendarioInstalacion.getState();

    const user = useAuthStore.getState().user;

    if (clickedIdHora != null) return;

    const hora = value?.replace('id-', '');

    const resp = await putPlanificationBlock({
      fecha: fechaSelecionada!,
      flota: codigoFlota!,
      horas: horasSelect,
      id_preventa: idPreventa!,
      tiempo: CacheKeyCalendarioENUM.TIEMPO_LIMITE,
      motivo: CacheKeyCalendarioENUM.MENSAJE_BLOQUEO,
    })

    if (resp.code !== 200) return;

    const jsonCache: ICalendarioProps = {
      horasSelect: horasSelect,
      valor_hora: +hora!,
      hora_limite: calcularTiempoMaxLimite(10),
      id_user: user?.id,
      id_hora: value!,
      codigo_flota: codigoFlota!,
      id_preventa: idPreventa!,
      fecha_selecionada: fechaSelecionada!,
      numero_tecnico: currentIndex
    };

    await postCache({
      key: `${CacheKeyCalendarioENUM.KEY_CACHE_PREAGENDAMIENTO}${idPreventa}`,
      value: jsonCache
    });

    set({ bloquear: true })
    set({ clickedIdHora: value })
    setCountdownInterval()
    setCountdownTimeOut(TiempoBloqueoENUM.COUNTDOWNTIMEOUT, true, true)
  },
  horasDisponibles: [],
  setHorasDisponibles(horasDisponibles) {
    set({ horasDisponibles })
  },

  fechaHoraDisponible: [],
  setFechaHoraDisponible: (fechaHoraDisponible) => {
    set({ fechaHoraDisponible })
  },

  codigoFlota: '',
  setCodigoFlota: (codigoFlota) => {
    set({ codigoFlota })
  },

  //fechaSelecionada: formatDate(new Date()),
  fechaSelecionada: null,
  setFechaSelecionada: (fechaSelecionada) => {
    const { fechaHoraDisponible } = useCalendarioInstalacion.getState();
    const fechaSelect = fechaHoraDisponible!.find(e => e.fecha == fechaSelecionada);
    set({ fechaSelecionada });

    let listaHoraAux: IHorasDisponibles[] = [];
    fechaSelect?.horas.forEach((h) => {

      if (h.fecha_hora_limite == null) { //hora libre
        listaHoraAux.push(h);
      } else {
        const tiempo = obtenerSegundosEntreFechas(h.fecha_hora_limite);
        if (tiempo <= 0) {
          listaHoraAux.push(h);
        }
      }
    });
    if (fechaSelecionada == formatDate(new Date)) {
      const newHorasDisponibles = listaHoraAux.filter(e => e.hora > convertirHoraIntervalo30Minutos());
      set({ horasDisponibles: newHorasDisponibles });
      return;
    }
    set({ horasDisponibles: listaHoraAux })
  },

  handleObtenerPlanificacion: async (codigoFlota) => {
    const setAlert = useUiStore.getState().setAlert;

    set({ isLoadingPlanificacion: true })
    set({ codigoFlota });

    ///* Limpiar datos al cambiar de flota
    set({ maxDate: null });
    set({ minDate: null });
    set({ fechaSelecionada: null });
    set({ fechaHoraDisponible: [] });
    set({ horasDisponibles: [] });
    set({ horasSelect: [] })

    try {
      ///* Obtener nuevo datos de planificacion
      const respFlota = await postHorasDisponiblesFlota({
        flota: codigoFlota,
        limite: 6,
        incluir_expirados: true
      });
      const dataFlota = respFlota.data;
      const firstElement = dataFlota.at(0);

      if (dataFlota.length === 0)
        return setAlert(true, texto.flota_sin_planificacion, AlertSeverityEnum.warning);

      set({ fechaSelecionada: firstElement?.fecha })
      set({ minDate: firstElement?.fecha })
      set({ maxDate: dataFlota.at(dataFlota.length - 1)?.fecha })
      set({ fechaHoraDisponible: dataFlota })

      get().setFechaSelecionada(firstElement?.fecha!);

      /* if (firstElement?.fecha == formatDate(new Date)) {
        const newHorasDisponibles = firstElement.horas.filter(e => e.hora > convertirHoraIntervalo30Minutos());
        set({ horasDisponibles: newHorasDisponibles })
        return;
      }

      set({ horasDisponibles: firstElement?.horas }) */

      //set({ horasDisponibles: firstElement?.horas })
      //set({ aux: true });


    } catch (error) {

      set({ fechaHoraDisponible: null })
      //setAlert(true, 'No se ha encontrado una planificación para el técnico seleccionado.', AlertSeverityEnum.warning);

    } finally {
      set({ isLoadingPlanificacion: false })
    }


  },
  handleVerificarCache: async (key, codigoFlota, idPreventa, _navigate): Promise<ICalendarioProps | null> => {

    try {
      const {
        setCountdownInterval,
        setCountdownTimeOut,

      } = useCalendarioInstalacion.getState();

      set({ idPreventa })

      const resp = await getCache(key)

      if (resp.code != 200) return null; ///* No hay datos en cache

      const respFlota = await postHorasDisponiblesFlota({
        flota: codigoFlota,
        limite: 6,
        incluir_expirados: true
      });
      const dataFlota = respFlota.data;

      set({ codigoFlota });
      set({ fechaHoraDisponible: dataFlota });
      //set({ aux: true });

      const dataCalendario = resp.data as ICalendarioProps;

      if (dataCalendario.id_preventa == idPreventa &&
        calcularSegundosHoraSeleccionada(`${dataCalendario.hora_limite!}`) > 0
      ) return null;

      const tiempoRestante = calcularDiferenciaDeTiempo(horaActualSistema(), dataCalendario.hora_limite!);

      set({ minDate: dataFlota.at(0)?.fecha });
      set({ maxDate: dataFlota.at(dataFlota.length - 1)?.fecha });
      set({ fechaHoraDisponible: dataFlota });
      set({ codigoFlota: dataCalendario.codigo_flota });
      set({ horasSelect: dataCalendario.horasSelect });
      set({ horasSelect: dataCalendario.horasSelect });

      set({ fechaSelecionada: dataCalendario.fecha_selecionada });
      set({ clickedIdHora: dataCalendario.id_hora });
      set({ horasDisponibles: dataFlota.find(e => e.fecha === dataCalendario.fecha_selecionada)?.horas ?? [] });


      set({ bloquear: true });
      set({ countdown: tiempoRestante });
      setCountdownInterval();
      setCountdownTimeOut(tiempoRestante * 1000, false, true);

      return dataCalendario;

    } catch (error) {

      throw new Error(`Error ${error}`);
      //set({ fechaHoraDisponible: null });
      //set({ bloquear: true });
      //navigate && navigate(ROUTER_PATHS.ventas.preventasNav);
      //handleAxiosError(error, texto.flota_sin_planificacion, AlertSeverityEnum.warning)
    }




  },
  handleRecargarHoras: async () => {
    const { codigoFlota,
      fechaSelecionada,
    } = useCalendarioInstalacion.getState();
    const respFlota = await postHorasDisponiblesFlota({
      flota: codigoFlota!,
      limite: 6,
      incluir_expirados: true
    });
    const horas = respFlota.data.find(e => e.fecha == fechaSelecionada)?.horas;
    set({ fechaHoraDisponible: respFlota.data });

    var listaHoraAux: IHorasDisponibles[] = [];
    horas?.forEach((h) => {
      if (h.fecha_hora_limite == null) { //hora libre
        listaHoraAux.push(h);
      } else {
        //var auxFechaLimite = h.fecha_hora_limite.split(' ');
        //const tiempo = calcularDiferenciaHorasEnSegundos(auxFechaLimite[1]);
        const tiempo = obtenerSegundosEntreFechas(h.fecha_hora_limite);
        if (tiempo <= 0) {
          listaHoraAux.push(h);
        }
      }
    });

    if (fechaSelecionada == formatDate(new Date)) {
      const newHorasDisponibles = listaHoraAux.filter(e => e.hora > convertirHoraIntervalo30Minutos());
      set({ horasDisponibles: newHorasDisponibles });
      return;
    }
    set({ horasDisponibles: listaHoraAux })
  },

  handleFechaCalendario: (fecha): boolean => {
    const { fechaHoraDisponible } = useCalendarioInstalacion.getState();

    for (let index = 0; index < fechaHoraDisponible!.length; index++) {
      const element = fechaHoraDisponible![index].fecha;
      const horaVacia = fechaHoraDisponible![index].horas;
      if (fecha == element && horaVacia.length > 0) return false;
    }

    return true;
  },

  handleVerificarHoraSeleccionada: async (hora) => {


    const setAlert = useUiStore.getState().setAlert;

    const {
      fechaSelecionada,
      codigoFlota,
      clickedIdHora,
    } = useCalendarioInstalacion.getState();

    if (clickedIdHora != null) return;

    const respFlota = await postHorasDisponiblesFlota({
      flota: codigoFlota!,
      limite: 6,
      incluir_expirados: true
    });
    const fechaSelect = respFlota.data.find(e => e.fecha == fechaSelecionada);

    const horaValid = fechaSelect?.horas.find(e => e.hora == hora);

    if (horaValid == undefined) return setAlert(
      true,
      texto.hora_ocupada,
      AlertSeverityEnum.info
    );

    if (horaValid && horaValid.fecha_hora_limite != null) {
      const aux = horaValid.fecha_hora_limite.split(' ');
      if (calcularDiferenciaDeTiempo(horaActualSistema(), aux[1]) > 0) {
        return setAlert(
          true,
          texto.hora_ocupada,
          AlertSeverityEnum.info
        );
      }
    }

    ///* Hora esta bloqueado o no existe

    const resp = verificarHoras(fechaSelect?.horas!, hora);

    if (!resp.valido) return setAlert(
      true,
      texto.hora_min_planificacion,
      AlertSeverityEnum.info
    );

    set({ horasSelect: resp.arrayHoras })
    set({ modal: true })
  }
}));

export default useCalendarioInstalacion;
